import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { useUpcomingEvent } from '../../hooks/useUpcomingEvent';
import { useCheerEvent } from '../../hooks/useCheerEvent';

const WRAPPER_STYLE = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: '1rem',
  marginBottom: '1.5rem',
};

const CARD_STYLE = {
  background: 'rgba(255, 215, 0, 0.06)',
  border: '1px solid rgba(255, 215, 0, 0.28)',
  borderRadius: '14px',
  padding: '1.1rem 1.25rem',
};

const HEADING_STYLE = {
  color: '#FFD700',
  margin: '0 0 0.75rem 0',
  fontSize: '0.85rem',
  letterSpacing: '1px',
  fontWeight: 800,
};

const LINK_STYLE = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  color: '#fff',
  textDecoration: 'none',
  padding: '0.45rem 0',
  fontWeight: 600,
  fontSize: '0.95rem',
};

const buildMailto = (subject) =>
  `mailto:RandallstownPanthers@gmail.com?subject=${encodeURIComponent(subject)}`;

const ContactCard = ({ title, contacts, mailSubject, testId }) => (
  <div style={CARD_STYLE} data-testid={testId}>
    <h4 style={HEADING_STYLE}>{title}</h4>
    {contacts.map((c) => (
      <a
        key={c.phone}
        href={`tel:${c.phone.replace(/[^\d+]/g, '')}`}
        style={LINK_STYLE}
        data-testid={`jamboree-coach-${c.name.replace(/\s+/g, '-').toLowerCase()}`}
      >
        <Phone size={16} style={{ color: '#FFD700' }} />
        {c.name} — {c.phone}
      </a>
    ))}
    <a
      href={buildMailto(mailSubject)}
      style={{ ...LINK_STYLE, color: '#FFD700' }}
      data-testid={`jamboree-mailto-${testId}`}
    >
      <Mail size={16} />
      Email Coaches
    </a>
  </div>
);

const JamboreeCoachContacts = () => {
  const { event: upcomingEvent } = useUpcomingEvent();
  const { event: cheerJamboree } = useCheerEvent();
  return (
  <div style={WRAPPER_STYLE} data-testid="jamboree-coach-contacts">
    <ContactCard
      title="FOOTBALL & FLAG · COACH LINE"
      contacts={upcomingEvent.contacts}
      mailSubject="Panthers Classic Jamboree — Team Registration"
      testId="jamboree-football-contacts"
    />
    <ContactCard
      title="CHEER · COACH LINE"
      contacts={cheerJamboree.contacts}
      mailSubject="Cheer Jamboree — Squad Registration"
      testId="jamboree-cheer-contacts"
    />
  </div>
  );
};

export default JamboreeCoachContacts;
